var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgBlock = function SvgBlock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 21 21",
    fill: "currentColor"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 17.539a7.5 7.5 0 100-15 7.5 7.5 0 000 15zM15.544 4.9L5.456 15.177",
    stroke: "#F4B718",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgBlock;